import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {
  Flex,
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import PostEditorScheduleTimePicker from "./PostEditorScheduleTimePicker";

const PostEditorAddDraftTimePickerModal = ({ onClose, onConfirm, ...rest }) => {
  const { t } = useTranslation(["planner", "common"]);

  return (
    <Modal
      autoFocus={false}
      returnFocusOnClose={false}
      isOpen
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("post_editor.add_draft_time.title")}</ModalHeader>
        <ModalBody>
          <Flex>
            <PostEditorScheduleTimePicker allowEmptyTime  {...rest} />
          </Flex>
        </ModalBody>
        <ModalFooter>
          <ButtonGroup size="sm" spacing="3">
            <Button onClick={onClose}>{t("cancel", { ns: "common" })}</Button>
            <Button variant="solid" onClick={onConfirm}>
              {t("post_editor.add_draft_time.confirm")}
            </Button>
          </ButtonGroup>
        </ModalFooter>
        <ModalCloseButton />
      </ModalContent>
    </Modal>
  );
};

PostEditorAddDraftTimePickerModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

PostEditorAddDraftTimePickerModal.defaultProps = {};

export default PostEditorAddDraftTimePickerModal;
